import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
const validateFunction = ({ path, pathName }) => {
  switch (pathName) {
    case ":assessmentId":
      return !isNaN(path);
    case ":mode":
      return _.includes(["edit", "create", "view"], path);
  }
};
export default store => {
  return {
    path: "le/:leId/:mode",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "unit-planner" */ "./LeDetails"),
          import(
            /* webpackChunkName: "unit-planner" */ "LearningEngagement/modules/LeModule"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "UnitPlans/modules/UnitPlanModule"
          ),
        ]).then(([importedModule0, importedModule1, importedModule2]) => {
          const component = importedModule0.default;
          const injectedModule = importedModule1;
          const reducer = importedModule2.default;
          injectReducer(store, {
            key: injectedModule.NAME,
            reducer: injectedModule.default,
          });
          injectReducer(store, {
            key: "unitPlans",
            reducer,
          });
          return withDynamicUrlValidation({
            component,
            urlValidationType: "customValidation",
            customUrlValidationFunction: validateFunction,
          });
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
  };
};
